import * as _ from "lodash";
import {BackendType} from "@/shared/DataService/BackendType";

export default class AppSettings {

    /**
     * Gets or sets whether to use the dark theme.
     */
    dark: boolean = true;

    /**
     * The type of backend in use.
     * @type {BackendType.LocalStore}
     */
    backend: BackendType = BackendType.LocalStore;

    toJson() {
        return {
            dark: this.dark,
            backend: this.backend
        }
    }

    static fromString(raw: string) {
        const settings = new AppSettings();
        _.assign(settings, JSON.parse(raw));
        return settings;
    }
}
